
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component

export default class extends Vue {
  @Prop() private dialogVisible!: boolean
  private visible = this.dialogVisible

  @Watch('dialogVisible', { deep: true, immediate: true })
  handleWatch (val: boolean) {
    this.visible = val
  }

  hanlderEnter (): void {
    this.$emit('hanlderclick')
  }
}
